import React, { FC, useState, useEffect } from 'react'
import styles from './ModalCardContent.module.scss'
import classNames from 'classnames'
import { CardEntity } from '../../ducks/cards/types'

interface PropsType {
  card: CardEntity
}

const ModalCardContent: FC<PropsType> = ({card}) => {
  return (
    <>
      <div className= { styles.imageContent }>
        { card.imageURL && card.imageURL.large ? <img src={ card.imageURL.large } /> : <span className={ styles.noImage }>No Image </span> }
      </div>
      <div className= { styles.cardContent }>
        <div className= { styles.heading }>
          { card.name }（{ card.ruby }）
        </div>
        <div className= { styles.detail }>
          <span className= { styles.item }>年齢<em>{card.age ? card.age : '-'}</em>歳</span>
          <span className= { styles.item }>身長<em>{card.height ? card.height : '-'}</em>cm</span>
          <span className= { styles.item }><em>{card.cup ? card.cup : '-'}</em>カップ</span>
        </div>
        <div className= { classNames(styles.detail, styles.supplement) }>
          <span className= { styles.item }>B<em>{card.bust}</em></span>
          <span className= { styles.item }>W<em>{card.waist}</em></span>
          <span className= { styles.item }>H<em>{card.hip}</em></span>
        </div>
        <div className= { classNames(styles.detail) }>
          趣味: { card.hobby }
        </div>
      </div>
    </>
  )
}

export default ModalCardContent
